// 阅读详情页面
import React from "react";
import { Button, NavBar, Icon } from "antd-mobile";
import { useHistory } from "react-router";
import styled from "styled-components";

const ReadDetailBox = styled.div`
  width: 100vw;
  height: 100vh;
  background: white;
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 10px;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }
  .btn {
    width: 200px;
    border-radius: 4px;
    background: blue;
    color: white;
    margin: 0 auto;
    font-size: 14px;
  }
  .am-icon-md {
    width: 30px;
    height: 30px;
  }
`;

export default function ReadDetail() {
  const history = useHistory();
  return (
    <div>
      <ReadDetailBox>
        <NavBar
          style={{
            width: "100%",
            background: "white",
            color: "black",
            fontWeight: "bold",
            fontSize: 20,
          }}
          icon={
            <Icon
              type="left"
              onClick={() => {
                window.location.href = "/colseWebView";
              }}
            />
          }
        >
          NMIBC计算器
        </NavBar>
        <div className="content">
          <h3 style={{ color: "blue" }}>
            非肌层浸润性膀胱癌(NMIBC)危险度计算器
          </h3>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "0 5px",
              height: 280,
              justifyContent: "space-between",
            }}
          >
            <span style={{ textAlign: "justify", textIndent: 32 }}>
              此计算器参考了2020EAU膀胱癌诊治指南整理完成，旨在更好地帮助泌尿外科医生对非肌层浸润性膀胱癌患者危险程度进行评估，计算结果仅供参考,不构成任何医学诊断结果。
            </span>
            <span style={{ textAlign: "justify", textIndent: 32 }}>
              如果患者有原发性原位癌（不伴发乳头状瘤），则患者属于高危组。
            </span>
            <span style={{ textAlign: "justify", textIndent: 32 }}>
              如果患者前列腺尿道伴发有原位癌、淋巴血管侵犯、或者有以下病理组织类型之一，微小乳头状瘤、浆细胞样、肉瘤样或神经内分泌样肿瘤，则患者属于极高危组，此情况已经超出计算范畴。
            </span>
            <span style={{ textAlign: "justify", textIndent: 32 }}>
              病理分级依据WHO1973膀胱肿瘤分级系统。
            </span>
            <span style={{ textAlign: "justify", textIndent: 32 }}>
              此计算器由优若通网络科技有限公司荣誉出品。
            </span>
            <span style={{ textAlign: "justify",textIndent: 32 }}>
              EAU膀胱癌诊治指南的著作权属于以EAU机构(https://eaucougree.uroweb.org)
            </span>
          </div>
        </div>
        <Button
          className="btn"
          onClick={() => history.push("/doctor/scoreWord")}
        >
          了解，进行下一步
        </Button>
      </ReadDetailBox>
    </div>
  );
}
